<template>
    <div>
        <v-dialog v-model="dialog" max-width="500" persistent>
            <v-card tile max-height="85vh">
                <v-toolbar color="white">
                    <v-toolbar-title class="text-primary">مرتب سازی</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialog = false">
                        <v-icon size="23" color="primary">close</v-icon>
                    </v-btn>
                </v-toolbar>
                <draggable @end="updateOrder()" handle=".handle" animation="200" tag="ul" v-model="data" item-key="id" class="px-3">
                    <template #item="{element}">
                        <li style="list-style: none;">
                            <v-row dense align="center" class="my-2 mx-0 rounded pa-2 bg-white department-customFields-draggableCards">
                                <v-col cols="auto">
                                    <v-icon class="handle" color="secondary" size="24" style="cursor: move">drag_indicator</v-icon>
                                </v-col>
                                <v-col>
                                    <p class="mb-0 text-small text-grey-darken-1 font-weight-bold user-select-none">{{ element.name }}</p>
                                </v-col>
                            </v-row>
                        </li>
                    </template>
                </draggable>
                <div class="d-flex pa-3 bg-white">
                    <v-btn @click="submit" color="success">ثبت اطلاعات</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="dialog = false" color="error" variant="text">انصراف</v-btn>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import draggable from 'vuedraggable';
export default {
    data() {
        return {
            dialog: false,
            loaded: false,
            data: []
        };
    },
    components: {
      draggable
    },
    props: {
        type: {
            type: String,
        },
    },
    methods: {
        updateOrder() {
            for (let index = 0; index < this.data.length; index++) {
                this.data[index].order = index;
            }
        },
        async openDialog() {
            if (!this.loaded) {
                this.$loading.start();
                let res = await this.$getOrder(this.type);
                if (res && res.status == 'OK')
                    this.data = res.data;
                this.loaded = true;
                this.$loading.finish();
            }
            this.dialog = true;
        },
        async submit() {
            this.$loading.start();
            let res = await this.$updateOrder(this.type, this.data);
            if (res && res.status == 'UPDATED')
                this.$toast.success(res.message);
            this.dialog = false;
            this.$emit('updated');
            this.$loading.finish();
        },
    },
};
</script>
